import { useEffect, useState } from "react";
import { getAdminHeaders } from "./adminApi";

export default function AdminPlatformSettings() {
  const [form, setForm] = useState({
    require_profile_to_view_detail: 1,
    unverified_weekly_message_limit: 2,
  });
  const [updatedAt, setUpdatedAt] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const loadSettings = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/admin/platform-settings", {
        headers: getAdminHeaders(),
      });
      const data = await res.json();
      if (res.ok) {
        setForm({
          require_profile_to_view_detail: data.require_profile_to_view_detail ? 1 : 0,
          unverified_weekly_message_limit: data.unverified_weekly_message_limit ?? 2,
        });
        setUpdatedAt(data.updated_at || "");
      } else {
        alert(data.detail || "加载失败");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const saveSettings = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage("");
    try {
      const res = await fetch("/api/admin/platform-settings", {
        method: "PATCH",
        headers: getAdminHeaders(true),
        body: JSON.stringify({
          require_profile_to_view_detail: form.require_profile_to_view_detail ? 1 : 0,
          unverified_weekly_message_limit: Number(form.unverified_weekly_message_limit),
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        alert(data.detail || "保存失败");
        return;
      }
      setForm({
        require_profile_to_view_detail: data.settings.require_profile_to_view_detail ? 1 : 0,
        unverified_weekly_message_limit: data.settings.unverified_weekly_message_limit,
      });
      setUpdatedAt(data.settings.updated_at || "");
      setMessage("已保存");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="text-gray-500">加载中...</div>;
  }

  return (
    <div className="max-w-2xl">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">平台规则</h2>
        <p className="text-sm text-gray-500 mt-1">
          控制会员查看资料门槛与未认证用户的聊天额度
        </p>
        {updatedAt && (
          <p className="text-xs text-gray-400 mt-2">最近更新：{updatedAt}</p>
        )}
      </div>

      <form
        onSubmit={saveSettings}
        className="bg-white rounded-2xl shadow p-6 space-y-6"
      >
        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={Boolean(form.require_profile_to_view_detail)}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                require_profile_to_view_detail: e.target.checked ? 1 : 0,
              }))
            }
            className="mt-1"
          />
          <span>
            <span className="font-medium text-gray-900 block">
              完善资料后才能查看他人详情
            </span>
            <span className="text-sm text-gray-500">
              开启后，未完善个人资料的会员无法打开其他会员的资料页（自己的资料页不受影响）
            </span>
          </span>
        </label>

        <div>
          <label className="block font-medium text-gray-900 mb-2">
            未认证会员每周可发消息条数
          </label>
          <input
            type="number"
            min="0"
            value={form.unverified_weekly_message_limit}
            onChange={(e) =>
              setForm((prev) => ({
                ...prev,
                unverified_weekly_message_limit: e.target.value,
              }))
            }
            className="w-40 border rounded-xl px-4 py-2"
          />
          <p className="text-sm text-gray-500 mt-2">
            未上传身份证并通过认证的会员，每周最多可发送上述条数；设为 0 表示完全禁止聊天。已认证会员不限条数。
          </p>
        </div>

        <div className="flex items-center gap-4">
          <button
            type="submit"
            disabled={saving}
            className="px-6 py-3 rounded-xl bg-blue-600 text-white font-bold disabled:opacity-60"
          >
            {saving ? "保存中..." : "保存设置"}
          </button>
          {message && <span className="text-green-600 text-sm">{message}</span>}
        </div>
      </form>
    </div>
  );
}
